/* @flow */
import React from 'react';
import Modal from 'react-modal';

import AccountLinkingComposerSidebarServicesContainer from '../../containers/AccountLinkingComposerSidebarServicesContainer';
import ComposerIntegrationsContent from './ComposerIntegrationsContent';
import ComposerIntegrationsServices from './ComposerIntegrationsServices';
import TooltipHovercardIconButton from 'translations/components/TooltipHovercardIconButton';
import type { UploadRequestHandler, ThumbnailHandler } from 'lib/fileUploadHelper';

type Props = {
  fetchPolicy?: string,
  addLinkedContent: (*) => void,
  hasFile?: boolean,
  hasLinks?: boolean,
  uploadRequest: UploadRequestHandler,
  loadThumbnail: ThumbnailHandler,
};

type State = {
  viewingSource: ?*,
};

class ComposerIntegrations extends React.Component<Props, State> {
  state: State = {
    viewingSource: null,
  };

  viewContent = (contentSource: *) => {
    this.setState({
      viewingSource: contentSource,
    });
  };

  viewSources = (reloadData: boolean, refetchCallback: Function) => {
    if (reloadData) {
      refetchCallback();
    }

    this.setState({
      viewingSource: null,
    });
  };

  closeContentModal = () => {
    this.setState({
      viewingSource: null,
    });
  };

  render() {
    const {
      addLinkedContent,
      fetchPolicy,
      hasFile,
      hasLinks,
      uploadRequest,
      loadThumbnail,
      ...props
    } = this.props;
    const { viewingSource } = this.state;

    return (
      <AccountLinkingComposerSidebarServicesContainer fetchPolicy={fetchPolicy}>
        {({ loading, sources, error, refetch }) => {
          return (
            <>
              <Modal isOpen={!!viewingSource}>
                <ComposerIntegrationsContent
                  onRequestHide={this.closeContentModal}
                  onViewSources={(reloadData: boolean) => this.viewSources(reloadData, refetch)}
                  addLinkedContent={content => {
                    addLinkedContent(content);
                    this.closeContentModal();
                  }}
                  contentSource={viewingSource}
                />
              </Modal>
              <TooltipHovercardIconButton
                data-test="composer-integrations"
                controlled
                icon="paperclip-stroked"
                switchedOn={hasFile || hasLinks}
                layerAlignment="left"
                layerPlacement="top"
                layer={layerTrigger => (
                  <ComposerIntegrationsServices
                    error={error}
                    sources={sources}
                    loading={loading}
                    onViewContent={this.viewContent}
                    reloadContentSources={refetch}
                    onAttachFile={() => layerTrigger.hideLayer()}
                    hasFile={hasFile}
                    uploadRequest={uploadRequest}
                    loadThumbnail={loadThumbnail}
                  />
                )}
                tooltipText="Add content"
                {...props}
              />
            </>
          );
        }}
      </AccountLinkingComposerSidebarServicesContainer>
    );
  }
}

export default ComposerIntegrations;
